import List from '@mui/material/List';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';

import NavItem from './NavItem';
import NavCollapse from './NavCollapse';
import { useGetMenuMaster } from 'api/menu';
import { useAuth } from 'contexts/AuthContext';
import { NavItemType } from 'types/menu';
import { canAccess } from 'menu-items/access';

type NavGroupProps = {
  item: NavItemType;
};

export default function NavGroup({ item }: NavGroupProps) {
  const { menuMaster } = useGetMenuMaster();
  const { hasPermission, permissions } = useAuth();
  const drawerOpen = menuMaster.isDashboardDrawerOpened;

  const filteredChildren = item.children?.filter((child) => canAccess(child, { permissions, hasPermission }));

  const navCollapse = filteredChildren?.map((menuItem) => {
    switch (menuItem.type) {
      case 'collapse':
        return <NavCollapse key={menuItem.id} menu={menuItem} level={1} />;
      case 'item':
        return <NavItem key={menuItem.id} item={menuItem} level={1} />;
      default:
        return (
          <Typography key={menuItem.id} variant="h6" color="error" align="center">
            Fix - Group Collapse or Items
          </Typography>
        );
    }
  });

  return (
    <List
      subheader={
        item.title &&
        drawerOpen && (
          <Box sx={{ pl: 3, pr: 2, mb: 1, mt: 0.5 }}>
            <Typography
              sx={{
                fontSize: '0.6875rem',
                fontWeight: 700,
                letterSpacing: '0.08em',
                textTransform: 'uppercase',
                color: 'text.secondary'
              }}
            >
              {item.title}
            </Typography>
          </Box>
        )
      }
      sx={{ mb: drawerOpen ? 1.5 : 0, py: 0, zIndex: 0 }}
    >
      {navCollapse}
    </List>
  );
}
